// extracted by mini-css-extract-plugin
export default {"Candle":"styles_Candle__Y-Z0d","hidden":"styles_hidden__QJAsg","line":"styles_line__DPlF-","draw":"styles_draw__Q6fn6"};